export default "<p>\r\n  updateplaceamachine works!\r\n</p>\r\n"